const {
  REACT_APP_BASE_API_URL,
} = process.env;

export const transactionDetailsApiUrl = `${REACT_APP_BASE_API_URL}/transaction-details`;

